import { Button, Col, Form, notification, Row } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FC } from 'react'
import Reason from '../form-items/reason/reason'
import Stamp from '../../../../form-items/stamp/stamp'
import Initiator from '../form-items/initiator/initiator'
import {
    useCreateStampWriteOffMutation,
    useUpdateStampWriteOffMutation,
} from '../../../../../store/api/stamp-write-offs-api'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import StampWriteOff from '../../../../../types/api/stamp-write-off'
import FormValues from '../../types/form-values'
import extractCreateStampWriteOff from '../../helpers/extract-create-stamp-write-off'

export interface AppProps {
    stampWriteOff?: StampWriteOff
    onSuccess?: () => void
}

const App: FC<AppProps> = ({ stampWriteOff, onSuccess = () => {} }) => {
    const [form] = useForm()
    const [create, createState] = useCreateStampWriteOffMutation()
    const [update, updateState] = useUpdateStampWriteOffMutation()
    const initialValues: Partial<FormValues> | undefined = stampWriteOff
        ? {
              stamp: stampWriteOff.stamp.documentId,
              reason: stampWriteOff.reason,
              initiator: stampWriteOff.initiator?.documentId,
          }
        : undefined

    useErrorModal(createState, 'Не удалось сохранить списание')
    useErrorModal(updateState, 'Не удалось обновить списание')

    const onClick = async () => {
        try {
            await form.validateFields()
            const isEditing = !!stampWriteOff
            const values: FormValues = form.getFieldsValue()
            const body = extractCreateStampWriteOff(values)

            let result = null
            if (isEditing) result = await update({ docId: stampWriteOff.documentId, body })
            else result = await create(body)

            if ('data' in result && result.data) {
                onSuccess()
                notification.success({ message: 'Списание сохранено' })
            }
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Form form={form} initialValues={initialValues} layout={'vertical'}>
            <Row gutter={18}>
                <Col sm={8}>
                    <Stamp />
                </Col>
                <Col sm={8}>
                    <Reason />
                </Col>
                <Col sm={8}>
                    <Initiator />
                </Col>
            </Row>

            <Button
                type={'primary'}
                loading={createState.isLoading || updateState.isLoading}
                onClick={onClick}
            >
                Сохранить
            </Button>
        </Form>
    )
}

export default App
